import { LOGIN_SOURCE_IFRAME } from '@cont/Login/constants';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

const useIsLoginTriggeredFromIframe = () => {
  const router = useRouter();
  return useMemo(
    () =>
      router.query.is_iframe_login &&
      router.query.source === LOGIN_SOURCE_IFRAME,
    [router]
  );
};

export default useIsLoginTriggeredFromIframe;
